import styled from "styled-components"
import { grey } from "utilities/variables/colors"

export const StyledHeader = styled.header`
  width: 100%;
  padding: 24px;
  border-bottom: solid 1px ${grey};
`